<!--
 * @Author: Nie Wie
 * @Date: 2020-03-26 22:00:29
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-03-30 14:28:18
 * @Description: 切换
 -->

<template>
  <div class="tab-bar">
    <div :class="['tab-bar__item', 'tab-bar__item1', activeKey === 'Observe' ? 'tab-bar__active1' : null ]"
      @click="jumpTo('Observe')">观测时报</div>
    <div :class="['tab-bar__item', 'tab-bar__item2', activeKey === 'Work' ? 'tab-bar__active2' : null ]">开工月报</div>
    <div :class="['tab-bar__item', 'tab-bar__item3', activeKey === 'Season' ? 'tab-bar__active3' : null ]">监测季报</div>
  </div>
</template>

<script>
export default {
  computed: {
    activeKey() {
      return this.$route.name
    },
  },
  methods: {
    jumpTo(name) {
      this.$router.push({ name })
    },
  },
}
</script>

<style lang="scss">
$height: 88px;
.tab-bar {
  height: $height;
  position: relative;
  justify-content: space-around;
  background-image: linear-gradient(to right, #0E229A , #2130C7);
  font-family: PingFangSC-Regular,PingFang SC;
  font-size: 30px;
  color: #666;
}
.tab-bar__item {
  width: 250px;
  position: absolute;
  text-align: center;
  line-height: $height;
  background-color: #F1F5FF;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  // cursor: pointer; 等第三模块开发后 启用
}
.tab-bar__item1 {
  left: 0;
  border-radius: 24px 0 0 0;
  cursor: pointer;
}
.tab-bar__item2 {
  left: 250px;
  // cursor: pointer;
}
.tab-bar__item3 {
  left: 500px;
  border-radius: 0 24px 0 0;
}
.tab-bar__active1 {
  width: 287px;
  background-image: url(../../assets/images/select.png);
  color: #005EFF;
  z-index: 1;
}
.tab-bar__active2{
  width: 324px;
  left: 213px;
  background-image: url(../../assets/images/select-middle.png);
  color: #005EFF;
  z-index: 1;
}
.tab-bar__active3{
  width: 287px;
  background-image: url(../../assets/images/select.png);
  color: #005EFF;
  z-index: 1;
}
</style>
